/** @jsx jsx */
import {jsx, css} from '@emotion/core'
import styled from '@emotion/styled'
import {srOnly} from '../styles'
import vars from '../styles/vars'

const Wrapper = styled('div')`
    position: absolute;
    top: 2rem;
    right: 2rem;
    z-index: 1010;
`

const Button = styled('button')`
    font-size: 0.7rem;
    position: relative;
    background: none;
    border: none;
    width: auto;
    height: auto;
    padding: 0;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    @media screen and (min-width: ${vars.bpLargerThanMobile}) {
        font-size: 1rem;
    }

    @media screen and (min-width: ${vars.bpLargerThanTablet}) {
        display: none;
    }

    &:focus {
        outline: none;
    }

    &::before {
        content: '';
        position: absolute;
        box-sizing: border-box;
        width: 4.375em;
        height: 4.375em;
        border: 0.3125em solid transparent;
        top: calc(50% - 2.1875em);
        left: calc(50% - 2.1875em);
        border-radius: 100%;
        transition: all 0.3s ease-in-out;
    }
`

const MenuButton = props => {
    const linesActive = css`
        width: 2.1875em;
        background-color: ${vars.white};
        &:nth-of-type(2) {
            opacity: 0;
        }

        &:nth-of-type(1) {
            transform: translateY(0.8125em);
        }

        &:nth-of-type(3) {
            transform: translateY(-0.8125em) rotate(90deg);
        }
    `

    const line = css`
        width: 3.125em;
        height: 0.3125em;
        background-color: ${vars.black};
        display: block;
        margin: 0.5em auto;
        transition: all 0.3s ease-in-out;
        ${!props.isOpen || linesActive};
    `

    return (
        <Wrapper>
            <Button
                css={
                    !props.isOpen ||
                    css`
                        transform: rotate(45deg);

                        &::before {
                            border: 0.3125em solid ${vars.white};
                        }
                    `
                }
                onClick={props.handleClick}
            >
                <span css={line} />
                <span css={line} />
                <span css={line} />
                <span css={srOnly}>Toggle menu</span>
            </Button>
        </Wrapper>
    )
}

export default MenuButton
